export default "__VITE_ASSET__BSkPiL7d__"